module.exports = __webpack_public_path__ + "static/img/108_TO8_1799_og.9a1c70a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/108_TO8_1799_og.jpg
// module id = tkZ0
// module chunks = 0